import {StationDashboardModel} from '@/types/channel/station/station.model';
import {numberCommaString} from '@/utils/channel';
import React from 'react';
import {useStationData} from '@/stores/channel/station';
import {ChannelI18n, ChannelT} from '@/utils/i18n/channel';

interface BroadCastInfoProp {
  stationDashboard: StationDashboardModel;
}

const BroadCastInfo = ({stationDashboard}: BroadCastInfoProp) => {
  const {station} = useStationData();
  //방송국 개설일이 '2006.03.09'이전인 경우 '2006.03.09'로 표기하는 히스토리가 있음
  const getJoinedDate = () => {
    const joinedAt = station.detail?.joinedAt?.slice(0, 10);
    return joinedAt && joinedAt > '2006-03-09'
      ? ChannelI18n.d(joinedAt)
      : ChannelI18n.d('2006-03-09', {format: 'yyyy-MM-dd'});
  };

  const BroadCastInfoData = [
    {
      label: ChannelT('방송국 개설일'),
      value: getJoinedDate(),
    },
    {
      label: ChannelT('총 방송 시간'),
      value: ChannelT('{{hours}}시간', {
        placeholder: {
          hours: numberCommaString(
            Math.floor(stationDashboard.station.totalBroadcastTime! / 3600),
          ),
        },
      }),
    },
    {
      label: ChannelT('누적 유저'),
      value: ChannelT('{{count}}명', {
        placeholder: {
          count: numberCommaString(stationDashboard.upd.totalViewCount!),
        },
      }),
    },
    {
      label: ChannelT('누적 UP 수'),
      value: numberCommaString(stationDashboard.upd.totalOkCount!),
    },
    {
      label: ChannelT('오늘의 UP'),
      value: numberCommaString(
        stationDashboard.upd[`today${station.detail?.activeNo}OkCount`]!,
      ),
    },
    {
      label: ChannelT('누적 방문 수'),
      value: numberCommaString(stationDashboard.upd.totalVisitCount!),
    },
    {
      label: ChannelT('오늘 방문 수'),
      value: numberCommaString(
        stationDashboard.upd[`today${station.detail?.activeNo}VisitCount`]!,
      ),
    },
    {
      label: ChannelT('최근 방송일'),
      value: station?.detail?.liveStartedAt
        ? ChannelI18n.d(station?.detail?.liveStartedAt, {
            format: 'yyyy-MM-dd HH:mm',
          })
        : '-',
    },
  ];
  return (
    <>
      <dl>
        <dt>{ChannelT('방송 정보')}</dt>
        {BroadCastInfoData.map((item, index) => (
          <dd key={index}>
            <strong>{item.label}</strong>
            {item.value && (
              <b
                style={{textAlign: 'end'}}
                dangerouslySetInnerHTML={{__html: item.value}}
              />
            )}
          </dd>
        ))}
      </dl>
    </>
  );
};

export default BroadCastInfo;
